var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoja(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5835 16.4167C3.43072 16.2639 3.35433 16.0694 3.35433 15.8333C3.35433 15.5972 3.43072 15.4028 3.5835 15.25L4.72933 14.1042C4.28489 13.5347 3.94127 12.9028 3.6985 12.2083C3.45572 11.5139 3.33405 10.7778 3.3335 10C3.3335 8.13889 3.97933 6.5625 5.271 5.27083C6.56266 3.97917 8.13905 3.33333 10.0002 3.33333H16.6668V10C16.6668 11.8611 16.021 13.4375 14.7293 14.7292C13.4377 16.0208 11.8613 16.6667 10.0002 16.6667C9.22239 16.6667 8.48989 16.5453 7.80266 16.3025C7.11544 16.0597 6.48683 15.7158 5.91683 15.2708L4.75016 16.4167C4.59738 16.5694 4.40294 16.6458 4.16683 16.6458C3.93072 16.6458 3.73627 16.5694 3.5835 16.4167ZM6.9585 13.0417C7.11127 13.2222 7.30572 13.3089 7.54183 13.3017C7.77794 13.2944 7.97933 13.2078 8.146 13.0417L11.4168 9.77083C11.5835 9.60417 11.6668 9.40611 11.6668 9.17667C11.6668 8.94722 11.5835 8.74944 11.4168 8.58333C11.2641 8.43055 11.0696 8.35417 10.8335 8.35417C10.5974 8.35417 10.4029 8.43055 10.2502 8.58333L6.9585 11.875C6.80572 12.0278 6.72933 12.2189 6.72933 12.4483C6.72933 12.6778 6.80572 12.8756 6.9585 13.0417Z",
    fill: "#04FF08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoja);
export default __webpack_public_path__ + "static/media/hoja.c7f4192f1fa97fa02057c84d1eb64831.svg";
export { ForwardRef as ReactComponent };